import { IDataTableMenuEntry } from './DataTable.types';

/** Схлопывает лишние разделители (ведущие/хвостовые/подряд) в собранном меню. */
export function compressMenuDividers(entries: IDataTableMenuEntry[]): IDataTableMenuEntry[] {
    const out: IDataTableMenuEntry[] = [];
    for (const e of entries) {
        if (e.divider && (out.length === 0 || out[out.length - 1].divider)) continue;
        out.push(e);
    }
    while (out.length && out[out.length - 1].divider) out.pop();
    return out;
}
